<footer class="footer">
    <div class="container-fluid">
        <span class="app-version">
            W{{uiVersion}}A{{apiVersion}}
        </span>
    </div>
</footer>
